import { useEffect } from 'react';
import SignaturePad from 'signature_pad';
import Grid from '@material-ui/core/Grid';
import styles from './SignatureField.module.css';
import { Field } from 'redux-form';
import { required } from '../../../../shared/Forms/validations';
import * as React from 'react';

let signaturePad: SignaturePad;

const SignatureFieldCanvas = ({ hasInitial, clientName, input, enabled, meta, id }: any) => {
  useEffect(() => {
    const canvas = document.getElementById(`signature-pad-${id}`);
    signaturePad = new SignaturePad(canvas as any, {
      onEnd: () => input.onChange(signaturePad.toDataURL())
    });
    if (input.value) {
      const dimensions = hasInitial ? { width: 150, height: 100 } : { width: 225, height: 100 };
      signaturePad.fromDataURL(input.value, dimensions);
    }
    if (!enabled) {
      signaturePad.off();
    } else {
      signaturePad.on();
    }
  }, []);

  const clear = (evt: any) => {
    evt.preventDefault();
    signaturePad.clear();
    input.onChange('');
  };

  return (
    <>
      <Grid container justify="space-between" className={styles.signerNameAndClear}>
        <Grid item>
          <b>Name:</b> {clientName}
        </Grid>
        <Grid item>
          <button onClick={clear}>Clear</button>
        </Grid>
      </Grid>
      <Grid container justify="center">
        <canvas
          style={meta && meta.touched && meta.error ? { border: '1px solid red' } : {}}
          id={`signature-pad-${id}`}
          className={enabled ? styles.signaturePadCanvas : styles.disabledSignaturePadCanvas}
          width={hasInitial ? 150 : 225}
          height={100}
        />
      </Grid>
    </>
  );
};

const SignatureField = (props: {
  id: string;
  party: string;
  name: string;
  signature?: any;
  initial?: boolean;
  enabled: boolean;
  existingSignature?: any;
  image?: any;
}) => (
  <Grid
    container
    direction="column"
    alignItems="center"
    item
    className={styles.signatureFieldContainer}
    xs={12}
    md={6}>
    <span className={styles.signerParty}>
      <b>
        {props.party}
        's {props.initial ? 'Initials' : 'Signature'}
      </b>
    </span>
    <Grid container direction="column" className={styles.signaturePadContainer}>
      {props.image ? (
        <>
          <div className={styles.signerName}>
            <b>Name:</b> {props.name}
          </div>
          <Grid container justify="center">
            <img className={styles.existingSignatureImage} src={props.image} alt="Ben Signature" />
          </Grid>
        </>
      ) : (
        <Field
          name={props.initial ? 'clientInitials' : 'clientSignature'}
          clientName={props.name}
          id={props.id}
          hasInitial={props.initial}
          enabled={props.enabled}
          component={SignatureFieldCanvas}
          validate={required}
        />
      )}

      <Grid container justify="flex-end" className={styles.date}>
        <Grid item xs={8} className={styles.signedDate}>
          <b>Date Signed:</b> {new Date().toDateString()}
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);
export default SignatureField;
